import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
  Text,
} from 'react-native';
import {
  Button,
  Rating,
} from 'react-native-elements';
import Svg, {
  Rect,
} from 'react-native-svg';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientAuthenticated, AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import GetAppReviews from '../../q/GetAppReviews';
import AppBadge from '../../components/apps/AppBadge';
import ReviewBadge from '../../components/apps/ReviewBadge';
import App from '../../modules/data/App';

import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';
import starStandard from '../../../node_modules/react-native-ratings/src/images/star.png'; // FIXME(clairbee): fix webpack config instead

class Reviews extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Reviews';

    this.state = {
    };
  }

  render() {
    const {
      app,
      reviews,
      history,
      direction,
    } = this.props;

    return (
      <View style={styles.view.headed}>
        <View
          style={styles.view.form}
        >
          <View style={{
            flex: 1,
            flexDirection: direction,
          }}
          >
            {/* The above is the full-screen view that is either 1 or 2 columns. */}

            <View style={{
              ...(direction === 'row' && {
                flex: 1,
              }),
              flexDirection: 'column',
              alignItems: 'center',
            }}
            >
              {/* The above is either the first full-screen column, or the top wixed height part. */}
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                }}
              >
                <AppBadge
                  style={{
                    flex: 1,
                    maxWidth: 500,
                    marginBottom: 10,
                    margin: 10,
                  }}
                  data={app.data}
                />
              </View>
              {reviews.length > 0 && (
                <View
                  style={{
                    flexDirection: 'column',
                    marginBottom: 10,
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center',
                  }}
                >
                  {[5, 4, 3, 2, 1].map((rating) => {
                    let count = 0;
                    let total = 0;
                    reviews.forEach((review) => {
                      if (review.ratingApproved === rating) {
                        count += 1;
                      }
                      total += 1;
                    });
                    const percentage = Math.round((100 * count) / total);

                    return (
                      <View
                        key={rating}
                        style={{
                          flexDirection: 'row',
                          margin: 3,
                          marginHorizontal: 10,
                        }}
                      >
                        <Rating
                          type="custom"
                          ratingImage={starStandard}
                          imageSize={20}
                          readonly
                          startingValue={rating}
                          style={styles.appBadge.rating}
                        />
                        <View
                          style={{
                            borderColor: 'grey',
                            borderWidth: 1,
                            marginLeft: 10,
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                          }}
                        >
                          <Svg
                            height="20"
                            width="100"
                            viewBox="0 0 100 20"
                          >
                            <Rect
                              x="0"
                              y="0"
                              width={`${percentage}`}
                              height="20"
                              fill="rgb(255,192,0)"
                            />
                          </Svg>
                        </View>
                        <Text
                          style={{
                            alignSelf: 'center',
                            textAlign: 'left',
                            textAlignVertical: 'center',
                            marginLeft: 10,
                          }}
                        >
                          {count}
                        </Text>
                      </View>
                    );
                  })}
                </View>
              )}
            </View>
            {reviews.length <= 0 ? (
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Text>
                  {translate('app_reviews_none')}
                </Text>
              </View>
            ) : (
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                }}
              >
                {/* The above is either the second full-screen column, or the flexible bottom part. */}
                <View
                  style={{
                    flex: 1,
                    flexDirection: 'row',
                  }}
                >
                  <ScrollView
                    style={{
                      flex: 1,
                    }}
                    contentContainerStyle={{
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    containerStyle={{
                    }}
                  >
                    {reviews.map((review) => (
                      <View
                        style={{
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          justifyContent: 'center',
                        }}
                      >
                        <ReviewBadge
                          style={{
                            flex: 1,
                            maxWidth: 500,
                            marginBottom: 10,
                            margin: 10,
                          }}
                          key={review.uuids}
                          data={review}
                        />
                      </View>
                    ))}
                  </ScrollView>
                </View>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    title={translate('button_back')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    disabledStyle={styles.button.secondaryDisabled}
                    titleStyle={styles.button.secondaryTitle}
                    disabledTitleStyle={styles.button.secondaryTitleDisabled}
                    onPress={() => history.go(-1)}
                  />
                </View>
              </View>
            )}
          </View>
        </View>
      </View>
    );
  }
}

Reviews.defaultProps = {
  app: null,
  reviews: [],
};

Reviews.propTypes = {
  app: AORTypes.App,
  reviews: PropTypes.arrayOf(AORTypes.Review),
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
};

export default compose(
  graphql(GetApp, {
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientUnauthenticated,
      fetchPolicy: 'cache-and-network',
    }),
    client: AppSyncClientUnauthenticated,
  }),
  graphql(GetAppReviews, {
    props: (props) => {
      console.log('graphql returned: GetAppReviews: ');
      console.log(props.data);
      if (!props.data.queryAppReviews) {
        return {
          reviews: [],
        };
      }
      return {
        reviews: props.data.queryAppReviews.items,
      };
    },
    options: (props) => ({
      variables: {
        // props.ownProps.params.uuid???
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientAuthenticated(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAuthenticated(),
  })
)(Reviews);
